export default __webpack_public_path__ + "static/media/National Family Assurance.f860f577.svg";